module.exports = __webpack_public_path__ + "img/expired-link.149c233f.svg";